import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EmailTemplates = lazy(() =>
  import("@scenes/MessageComposition/Email/EmailTemplates/EmailTemplateLibrary/EmailTemplateList").then(
    (module) => ({
      default: module.EmailTemplateList,
    })
  )
);

export const emailTemplatesNRO: NavigationRoutingObject = {
  Component: EmailTemplates,
  componentFeatureFlippers: ["email_templates_nro_component"],
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("email-templates", "Email Templates"),
  pageNameForTracking: () => "Email Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("email-templates-description-nav", "Create and manage email templates"),
  icon: "nav-system-email-templates",
  getDeveloperNavigationAllowed: ({ hasPermissionForAnyScope, featureOn }) => {
    const isGranularPermissionsEnabled =
      featureOn("clip_granular_permissions_all") && featureOn("clip_granular_permission_basic_read_only");
    if (isGranularPermissionsEnabled) {
      // when granular permissions are enabled, always display in side navigation and render no permission view inside EmailTemplateList component
      return true;
    }
    return hasPermissionForAnyScope("basicReadOnly");
  },
  shouldShowTertiaryNavigationCallback: ({ featureOn, hasPermission }) => {
    const isGranularPermissionsEnabled =
      featureOn("clip_granular_permissions_all") && featureOn("clip_granular_permission_basic_read_only");
    if (isGranularPermissionsEnabled) {
      return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "viewEmailTemplates" });
    }
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
